import React from "react";
import MyTab from "../Interactions/MyTab";
import AchievementsInformation from "./AchievementsInformation";
import NationalGoldAchievement from "./NationalGoldAchievement";
import NationalSilverAchievements from "./NationalSilverAchievements";
import NationalBronzeAchievements from "./NationalBronzeAchievements";
const items = [
  {
    key: "1",
    label: "Gold Achievements",
    children: <NationalGoldAchievement />,
  },
  {
    key: "2",
    label: "Silver Achievements",
    children: <NationalSilverAchievements />,
  },
  {
    key: "3",
    label: "Bronze Achievements",
    children: <NationalBronzeAchievements />,
  },
];
const NationalAchievementsTabs = ({ setAchievement, setSelectedStepher }) => (
  <MyTab
    setSelectedStepher={setSelectedStepher}
    setAchievement={setAchievement}
    items={items}
  />
);
export default NationalAchievementsTabs;
